import { Injectable } from '@angular/core';

@Injectable()
export class DataLayerService {
  private dataLayer = window['dataLayer'];

  constructor() {}

  logEvent(event: any) {
    if (this.dataLayer) {
      this.dataLayer.push({ event });
    }
  }
}
